import fileSize from "filesize";

const toBytes = (value, fromUnit = "GB") => {
  const modifiers = {
    kb: 1024,
    mb: 1024 ** 2,
    gb: 1024 ** 3,
    tb: 1024 ** 4,
  };
  return value * modifiers[fromUnit.toLowerCase()];
};

const sizeFormat = (value, options = { round: 0 }) => {
  let val = parseFloat(value);
  if (Number.isNaN(val)) val = 0;
  return fileSize(val, options);
};

const fromGBFormat = (value, round = 0) => sizeFormat(toBytes(value, "GB"), { round });

export {
  fromGBFormat,
  sizeFormat,
  toBytes,
};
